export default __webpack_public_path__ + "static/media/filling-out-form.79217e99.svg";